export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.19-1032.41",
  commitId: "286562cd8b8c025f30e2b28066d0e241727f8bdc",
  commitTime: "2026-05-19T10:32:41.000Z",
});
